import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Leaf } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: '😴',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-14">
            Dormirás sin depender de pastillas
          </strong>{' '}
        </>
  }, {
    icon: '🧠',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-15">
            Tu mente dejará de repetir pendientes.
          </strong>{' '}
        </>
  }, {
    icon: '🌅',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-16">
            Despertarás sin presión en el pecho
          </strong>{' '}
          —
        </>
  }, {
    icon: '💚',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-17">
            Recuperarás tu versión calmada
          </strong>{' '}
        </>
  }, {
    icon: '🛡️',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-18">
            Tendrás un protocolo para noches difíciles
          </strong>{' '}
        </>
  }, {
    icon: '🌸',
    text: <>
          <strong className="text-[#4A5D3A]" data-id="element-19">
            Dejarás de sentirte "demasiado sensible"
          </strong>{' '}
        </>
  }];
  return <section className="px-6 py-5 max-w-4xl mx-auto" data-id="element-20">
      <FadeIn data-id="element-21">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#2D2A26] mb-8" data-id="element-22">
          Cuando apliques el Método de Rescate Botánico:
        </h2>

        <div className="space-y-4" data-id="element-23">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 md:gap-6 bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-[#4A5D3A]/10" data-id="element-24">
              <div className="text-3xl md:text-4xl shrink-0 bg-[#FAF6F0] w-14 h-14 rounded-full flex items-center justify-center" data-id="element-25">
                {benefit.icon}
              </div>
              <p className="text-lg md:text-xl text-[#2D2A26]/90 leading-relaxed pt-1 md:pt-2" data-id="element-26">
                {benefit.text}
              </p>
            </div>)}
        </div>
      </FadeIn>
    </section>;
}